// extracted by mini-css-extract-plugin
export default {"heading1":"heading1-module--heading1--I9SB7","primary":"heading1-module--primary--Ua4xX","secondary":"heading1-module--secondary--iHSKG","bold":"heading1-module--bold--oPZ6y"};